export const LOGO = "https://d33j98c122wnb5.cloudfront.net/antipartido/images/logo.svg"
export const LOGO_FULL = "https://d33j98c122wnb5.cloudfront.net/antipartido/images/logo_full.svg"
export const LOGO_DARK_MODE = "https://d33j98c122wnb5.cloudfront.net/antipartido/images/logo-dark-mode.svg"
export const LOGO_FULL_DARK_MODE = "https://d33j98c122wnb5.cloudfront.net/antipartido/images/logo-full-dark-mode.svg"
